<template>
  <form class="FORGOT-FORM" @submit.prevent="submit">
    <div class="h4 text-bold m-b-3">
      Password Reset
    </div>
    <div class="m-b-4 INSTRUCTION-TEXT" selenium="forgot-password-instructions">
      Enter the email you registered with and we’ll send you
      a link to reset your password.
    </div>

    <div
        :class="{ 'error': validation.hasError('email') }"
        :error="validation.firstError('email')"
        class="input-container m-b-4"
        selenium="forgot-password-email-input-container">
      <input
          v-vk-input
          v-model="email"
          class="input"
          selenium="input"
          type="text">
      <label class="input-label" selenium="label">Email</label>
    </div>

    <special-message ref="success" type="success" class="m-b-2" selenium="forgot-password-success">
      We sent instructions for resetting your password to the email provided.
    </special-message>

    <button
        :disabled="loading"
        type="submit"
        class="btn w-100 m-b-2"
        selenium="forgot-password-button">
      Reset My Password
    </button>
  </form>
</template>

<script>
import SimpleVueValidator, { Validator } from 'simple-vue-validator';
import { sendPasswordRecoveryEmail } from '@homeservices/api-kit/search/notifications';
import SpecialMessage from '@/components/SpecialMessage';

export default {
  name: 'password-forgot',
  components: {
    SpecialMessage,
  },
  mixins: [SimpleVueValidator.mixin],
  props: {
    defaultEmail: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      email: this.defaultEmail,
      loading: false,
    };
  },
  validators: {
    email (value) {
      return Validator.value(value)
        .required('Please enter your email address.')
        .email('Please enter a valid email address.');
    },
  },
  methods: {
    async submit () {
      this.$refs.success.hide();
      const valid = await this.$validate();

      if (valid) {
        this.loading = true;
        await sendPasswordRecoveryEmail({
          email: this.email,
          domain: window.location.host,
        });

        this.$refs.success.trigger(600000);
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.FORGOT-FORM {

  text-align: center;
  @include responsive(width, 100%, 576px);
  @include mobile-only () {
    padding: 2 * $unit;
  }
}
.INSTRUCTION-TEXT {
  font-size: 14px;
}
</style>
